import React from 'react';
// import logo from '../LandingHeader/logo.svg';
import logo from '../LandingHeader/google-classroom-128.svg';
import classes from './Footer.module.css';

import { ReactComponent as FacebookIcon } from '../../assets/facebook-icon.svg';
import { ReactComponent as InstagramIcon } from '../../assets/instagram-icon.svg';
import { ReactComponent as TwitterIcon } from '../../assets/twitter-icon.svg';
import { ReactComponent as LinkedInIcon } from '../../assets/linkedin-icon.svg';
import { ReactComponent as EmailIcon } from '../../assets/email-icon.svg';
import { ReactComponent as Youtube } from '../../assets/youtube.svg';

const Footer = () => {
    return (
        <div className={classes.container}>
            <div className={classes.logo}>
                <img alt='logo' src={logo} />
                <a href='/'>
                    <h3>StudyGroup</h3>
                </a>
            </div>
            <nav className={classes.links}>
                <a href='/#about_us'>About us</a>
                <a href='/#education'>Education</a>
                <div className={classes.separator} />
                <a href='/#whats_new'>What's New</a>
                {/* <a href='/#hero'>Login/Signup</a> */}
                <div className={classes.separator} />
                <a href='https://twitter.com/techstudygroup' target='_blank' rel='noreferrer'>
                    <TwitterIcon />
                </a>
                <a href='https://www.facebook.com/getrightchoice/' target='_blank' rel='noreferrer'>
                    <FacebookIcon />
                </a>
                <a href='https://www.instagram.com/techstudygroup/' target='_blank' rel='noreferrer'>
                    <InstagramIcon />
                </a>
                <a href='https://www.linkedin.com/company/techstudygroup/' target='_blank' rel='noreferrer'>
                    <LinkedInIcon />
                </a>
                <a href='https://www.youtube.com/@Ourtechstudygroup' target='_blank' rel='noreferrer'>
                    <Youtube />
                </a>
                <a href='mailto:bishan.shubhamsoft@gmail.com' target='_blank' rel='noreferrer'>
                    <EmailIcon />
                </a>
            </nav>
            <small className={classes.footnote}>
                &copy;{' '}
                <a href='/'>
                    <span>TechStudyGroup</span>
                </a>{' '}
                All rights reserved
            </small>
            <br />
            {/* <small className={classes.footnote}>
                <a href='/tnc'>
                    <span>Terms and Conditions</span>
                </a>
            </small> */}
        </div>
    );
};

export default Footer;
